<template>
  <v-container fluid class="pl-md-5 pb-15">
    <v-alert dense outlined type="error" v-if="error">
      <ul>
        <li v-for="item in error" :key="item.msg">{{ $t(item.msg) }}</li>
      </ul>
    </v-alert>
    <div class="text-h5 mt-5 mb-5">{{ $t("string5") }}</div>
    <div class="elevation-1 pa-5 mt-4 mb-16 white">
      <v-form ref="form" class="pt-9" v-model="valid" lazy-validation>
        <v-skeleton-loader v-if="loading" type="article"></v-skeleton-loader>
        <v-row>
          <v-col cols="10" md="6">
            <v-text-field
              prepend-icon="mdi-youtube"
              type="text"
              v-model="video_url"
              v-bind:label="$t('Pastevideourlfromyoutube')"
              outlined
              :rules="reqRules"
            ></v-text-field>
          </v-col>
          <v-col cols="auto">
            <v-btn
              dark
              x-large
              min-width="150"
              color="light-blue"
              @click="saveUrl"
            >
              <span class="mr-2">{{ $t("Add") }}</span>
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="!loading">
          <v-col v-for="(item, i) in videos" :key="i" cols="2">
            <div class="text-right pb-4">
              <v-btn icon color="red" @click="removeVideo(item)">
                <v-icon>mdi-delete-circle</v-icon>
              </v-btn>
            </div>
            <youtube
              :video-id="getVideoId(item)"
              player-width="100%"
              player-height="150px"
            ></youtube>
          </v-col>
        </v-row>
      </v-form>
      <v-footer fixed>
        <v-col class="text-center" cols="12">
          <v-btn
            color="light-blue"
            dark
            min-width="150"
            :to="{
              name: 'PartnerListingViewComponent',
              params: { id: parm }
            }"
          >
            <span>{{ $t("Done") }}</span>
          </v-btn>
        </v-col>
      </v-footer>
    </div>
    <WaitDialogComponent :waitDialog="waitDialog" />
  </v-container>
</template>

<script>
import timeoutMixin from "@/mixins/timeoutMixin.js";
import WaitDialogComponent from "@/components/layout/WaitDialogComponent.vue";
import ListingService from "@/services/ListingService";
import swal from "sweetalert";

export default {
  name: "EditYoutubeVideoComponent",
  components: { WaitDialogComponent },
  mixins: [timeoutMixin],
  data() {
    return {
      waitDialog: false,
      loading: true,
      parm: this.$route.params.id,
      valid: null,
      video_url: "",
      videos: [],
      error: null,
      reqRules: [
        value => !!value || this.$t("string719"),
        value => {
          const pattern = /^^(http(s)?:\/\/)?((w){3}.)?youtu(be|.be)?(\.com)?\/.+/;
          return pattern.test(value) || this.$t("string720");
        }
      ]
    };
  },
  created() {
    ListingService.getVideos({
      id: this.parm
    }).then(result => {
      this.videos = result.data.video_url;
      this.loading = false;
    });
  },
  methods: {
    getVideoId(val) {
      return this.$youtube.getIdFromURL(val.toString());
    },
    async saveUrl() {
      await this.$refs.form.validate();
      if (this.valid) {
        this.waitDialog = true;
        await ListingService.addYoutubeUrl({
          property_id: this.parm,
          video_url: this.video_url
        })
          .then(result => {
            setTimeout(
              () => (
                (this.waitDialog = false),
                (this.video_url = ""),
                this.$refs.form.reset(),
                (this.videos = result.data)
              ),
              500
            );
          })
          .catch(err => {
            this.error = err.response.data.errors;
            setTimeout(() => (this.waitDialog = false), 500);
          });
      }
    },
    removeVideo(data) {
      swal({
        text: this.$t("string691"),
        className: "custom-confirm",
        buttons: {
          cancel: this.$t("No"),
          confirm: this.$t("Yes")
        }
      }).then(value => {
        if (value) {
          this.waitDialog = true;
          ListingService.removeYoutubeUrl({
            item: data,
            property_id: this.parm
          })
            .then(result => {
              setTimeout(
                () => ((this.waitDialog = false), (this.videos = result.data)),
                500
              );
            })
            .catch(err => {
              this.error = err.response.data.errors;
              setTimeout(() => (this.waitDialog = false), 500);
            });
        }
      });
    }
  }
};
</script>

<style></style>
